import { queryOptions, useQuery } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { ProdutoUnidadeSchema } from '../types/ProdutoUnidade';

type ProdutoUnidadeGetParams = DefaultApiParams & {
    pesquisar?: string;
};

type ProdutoUnidadeGetProps = {
    idpk?: number;
    params?: ProdutoUnidadeGetParams;
};

const schema = registrosSchema(ProdutoUnidadeSchema);

function apiProdutoUnidadeGet(props?: ProdutoUnidadeGetProps) {
    return fetchApi({
        endpoint: 'ProdutoUnidade/ProdutoUnidade',
        idpk: props?.idpk,
        method: 'get',
        params: props?.params,
        schema,
    });
}

const API_PRODUTO_UNIDADE_GET_KEY = 'apiProdutoUnidadeGet';

function apiProdutoUnidadeGetQueryOptions(props?: ProdutoUnidadeGetProps) {
    return queryOptions({
        queryFn: () => apiProdutoUnidadeGet(props),
        queryKey: [API_PRODUTO_UNIDADE_GET_KEY, props],
        staleTime: 5 * 60 * 1000, // 5 minutos
    });
}

export function useProdutoUnidadeGetQuery() {
    return useQuery(apiProdutoUnidadeGetQueryOptions({ params: { orderby: 'pru_sigla' } }));
}
